import { api } from '@/lib/api';

import type { AuditLogRow } from './audit-format';

const PAGE_SIZE = 100;
const HARD_LIMIT = 10_000;

/**
 * Loads every financial audit row matching the current filters (capped),
 * so the PDF covers the filtered set rather than the on-screen page.
 */
export const fetchFinancialAuditForPdf = async (filters: {
  search?: string;
  action?: string;
  entityType?: string;
  dateFrom?: string | null;
  dateTo?: string | null;
}): Promise<AuditLogRow[]> => {
  const rows: AuditLogRow[] = [];
  let page = 1;
  let totalPages = 1;

  while (page <= totalPages && rows.length < HARD_LIMIT) {
    const result = await api.get<{
      data: AuditLogRow[];
      page: { totalItems: number; totalPages: number };
    }>('/audit/logs', {
      query: {
        page,
        pageSize: PAGE_SIZE,
        scope: 'financial',
        ...(filters.search ? { q: filters.search } : {}),
        ...(filters.action ? { action: filters.action } : {}),
        ...(filters.entityType ? { entityType: filters.entityType } : {}),
        ...(filters.dateFrom ? { dateFrom: filters.dateFrom } : {}),
        ...(filters.dateTo ? { dateTo: filters.dateTo } : {}),
        sort: '-createdAt',
      },
    });

    rows.push(...result.data);
    totalPages = result.page.totalPages;
    if (result.data.length === 0) break;
    page += 1;
  }

  return rows.slice(0, HARD_LIMIT);
};
